// extracted by mini-css-extract-plugin
export default {"cls1":"PaymentChannelType-RadioButtonContainer_cls1__z4olS","cls2":"PaymentChannelType-RadioButtonContainer_cls2__e0Kn- PaymentChannelType-RadioButtonContainer_cls1__z4olS"};